import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterMonAn({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    vat_tu: "",
    don_vi_tinh: null,
    nhom_vat_tu: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.vat_tu) {
      condition.$or.push({
        ma_vt: { $regex: filter.vat_tu?.split(" ")?.join(".*"), $options: "i" },
      });
      condition.$or.push({
        ten_vt: {
          $regex: filter.vat_tu?.split(" ")?.join(".*"),
          $options: "i",
        },
      });
    }
    if (filter.don_vi_tinh) {
      condition.ma_dvt = filter.don_vi_tinh.ma_dvt;
    }
    if (filter.nhom_vat_tu) {
      condition.ma_nvt = filter.nhom_vat_tu._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Tên, mã hàng"
        placeholder="Tìm theo mã, tên hàng"
        value={filter.vat_tu}
        onSearch={(val) => setFilter({ ...filter, vat_tu: val })}
      />
      <FilterSelectApi
        label="Đơn vị tính"
        placeholder="Chọn đơn vị tính"
        selectTitle="Chọn đơn vị tính"
        placeholderSearch="Tìm theo mã, tên đơn vị tính"
        apiCode="dmdvt"
        getOptionLabel={(option) => option.ten_dvt}
        checkEqual={(value, option) => value?.ma_dvt === option?.ma_dvt}
        searchFields={["ma_dvt", "ten_dvt"]}
        value={filter.don_vi_tinh}
        onChange={(val) => setFilter({ ...filter, don_vi_tinh: val })}
      />
      <FilterSelectApi
        label="Nhóm hàng"
        placeholder="Chọn nhóm hàng"
        selectTitle="Chọn nhóm hàng"
        placeholderSearch="Tìm theo tên nhóm hàng"
        apiCode="dmnvt"
        defaultCondition={{ la_nhom_hang_hoa: false }}
        getOptionLabel={(option) => option.ten_nvt}
        checkEqual={(value, option) => value?._id === option?._id}
        searchFields={["ten_nvt"]}
        value={filter.nhom_vat_tu}
        onChange={(val) => setFilter({ ...filter, nhom_vat_tu: val })}
      />
    </WrapperFilter>
  );
}

export default FilterMonAn;
